import React from "react"
import Image from "next/image"
import { motion } from "framer-motion"

type props = {
  image: any
}

export const PageShade: React.FC<props> = (props) => {
  return (
    <motion.div className="page-shade" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6, delay: 0.6 }}>
      <div className="page-shade-inner">
        <Image src={props.image} layout="fill" objectFit="cover" priority alt="background" />
      </div>
    </motion.div>
  )
}
